import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { CommonUtilities } from '../../assets/js/common-utilities';
import { CustomExceptionService } from '../errorHandlers/custom-exception.service';
import { User } from '../Models/User';
import { UserService } from '../Services/user.service';
declare var $: any;
import { v4 as SessionID } from 'uuid';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {
  menuMaster: MenuItem[];
  ScreenList: any[]
  AccessScreenList: any[]
  ModuleList: any
  RoleList: any
  appRoleList = [];
  appModuleList = [];
  appMarketCircleList = [];
  MarketCircle : any;

  _Signoffform: FormGroup
  _User: User
  constructor(private utility: CommonUtilities, private _UserService: UserService, private _CustomExceptionService: CustomExceptionService,
    private fb: FormBuilder,private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this.utility.customScrollbar();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // this.route.queryParams
    //   .subscribe(params => {
    //     console.log(params); // { orderby: "price" }
    //     sessionStorage["username"] = JSON.stringify(params.username);
    //     sessionStorage["role"] = JSON.stringify(params.role);
    //   });
    this._Signoffform = this.fb.group({
      username: [],
      password: [],
      role: [],
      userReferenceId: [],
      sessionid: [],
    });

    this._User = this._Signoffform.value
    this._User.username = JSON.parse(sessionStorage["username"])
    this._User.role = JSON.parse(sessionStorage["role"])
    //this._User.username = sessionStorage["username"]
    //this._User.role = sessionStorage["role"]
    var _sessionid = SessionID()
    // console.log(this._User)

    //var Session = sessionStorage["SessionId"]
    if (sessionStorage["SessionId"] != undefined) {
      
      if (this.menuMaster == undefined) {
        this.ScreenList = JSON.parse(sessionStorage["ScreenList"])
        // console.log("leftmenu",this.ScreenList)
        // this.AccessScreenList = this.ScreenList.filter(f=>f.parentid != null)
      // console.log("allow",this.AccessScreenList)
        this.menuMaster = this.ScreenList;
        // console.log("",this.menuMaster)
        for (var i = 0; i < this.menuMaster.length; i++) {
          this.menuMaster[i].label = this.ScreenList[i].displayname;
          this.menuMaster[i].routerLink = this.ScreenList[i].defaultrouterprovider;
        }
      }
    }
    else{
     
      if(urlParams.get('approval') != null)
      {
        return;
        this._UserService.GetUserAccessRightsDetailsinMailLink(urlParams.get('approval'), _sessionid).subscribe((result) => {
          // console.log()
          const resultJSON = JSON.parse(JSON.stringify(result));
          if (sessionStorage["SessionId"] == undefined)
          {
            // console.log("user", resultJSON);
            sessionStorage["SessionId"] = resultJSON.loggedUser.sessionid
            // console.log("nav", sessionStorage["SessionId"])
            this.ScreenList = resultJSON.lstUserScreens
            sessionStorage["ScreenList"] = JSON.stringify(this.ScreenList)
            // console.log(this.ScreenList)
            this.ModuleList = resultJSON.lstUserModules
            sessionStorage["ModuleList"] = JSON.stringify(this.ModuleList)
            // console.log("bh", JSON.parse(sessionStorage["ModuleList"]))
            this.RoleList = resultJSON.lstUserRoles
            sessionStorage["RoleList"] = JSON.stringify(this.RoleList)
            this.appRoleList = this.RoleList;
            this.appModuleList = this.ModuleList;
            console.log(3,this.appRoleList)
            //this.Role = this.appRoleList[0];
            //this.appMarketCircleList = resultJSON.lstMarketCircle

            //this.Module = this.appModuleList[0];
          }
          else{
            var Module = JSON.parse(sessionStorage["ModuleList"])
            var Role = JSON.parse(sessionStorage["RoleList"])
            //this.username = JSON.parse(sessionStorage["username"])
            this.appRoleList = Role
            console.log(2,this.appRoleList)
          }
          //alert(resultJSON.approvalStatus.approvalid)
          if(urlParams.get('status') != null)
          {
            //window.location.href = "/vApproval?status="+urlParams.get('status')+"&approvalid="+resultJSON.approvalStatus.approvalid
            window.location.href = "/vApproval"
          }
          else{
            window.location.href = "/vApproval?approvalid="+resultJSON.approvalStatus.approvalid
          }

        }, error => { this._CustomExceptionService.handleError(error); }
        );
      }
      else{
        this.route.queryParams
        .subscribe(params => {
          // console.log(params); // { orderby: "price" }
          sessionStorage["username"] = JSON.stringify(params.username);
          sessionStorage["role"] = JSON.stringify(params.role);
        });
        this._UserService.GetUserAccessRightsDetails(this._User, _sessionid).subscribe((result) => {
          // console.log()

          const resultJSON = JSON.parse(JSON.stringify(result));
          // console.log("user", resultJSON);
          sessionStorage["SessionId"] = resultJSON.loggedUser.sessionid
          // console.log("nav", sessionStorage["SessionId"])
          this.ScreenList = resultJSON.lstUserScreens
          sessionStorage["ScreenList"] = JSON.stringify(this.ScreenList)
          // console.log(this.ScreenList)
          this.ModuleList = resultJSON.lstUserModules
          sessionStorage["ModuleList"] = JSON.stringify(this.ModuleList)
          // console.log("bh", JSON.parse(sessionStorage["ModuleList"]))
          this.menuMaster = this.ScreenList;
          this.RoleList = resultJSON.lstUserRoles
          sessionStorage["RoleList"] = JSON.stringify(this.RoleList)
          this.appRoleList = this.RoleList;
          this.appModuleList = this.ModuleList;
          this.appMarketCircleList = resultJSON.lstMarketCircle
          this.MarketCircle = this.appMarketCircleList[0];

          console.log(resultJSON);

          console.log(1,this.appRoleList)


          if (this.menuMaster != null) {
            for (var i = 0; i < this.menuMaster.length; i++) {
              this.menuMaster[i].label = this.ScreenList[i].displayname;
              this.menuMaster[i].routerLink = this.ScreenList[i].defaultrouterprovider;
            }
          }
          // console.log("m", this.menuMaster)


        }, error => { this._CustomExceptionService.handleError(error); }
        );
      }

    }


    //  [
    //   { label: 'Dashboard', routerLink: '../cDashboard' },
    //   // {label: 'Company Profile', routerLink: '../AgentEnquiry'},
    //   { label: 'Temp Customer ', routerLink: '../vCustomer' },
    //   // {label: 'Temp Customer Information', routerLink: '../vCustomerinformation'},
    //   // {label: 'Service Locations & Operation Requirements', routerLink: '../cServiceLocation'},
    //   // {label: 'SKU (Stock Keeping Unit)', routerLink: '../cStockkeepingunit'},
    //   // {label: 'Costing & Contract Information', routerLink: '../cCosting'},
    //   // {label: 'Existing Vendor Details', routerLink: '../cExistingvendor'},
    //   // {label: 'Trade Reference', routerLink: '../cTradereference'},
    //   { label: 'Pre-Quote', routerLink: '../vprequote' },
    //   { label: 'Pre-Quote Sign-Off', routerLink: '../cPrequotesignoff' },
    //   { label: 'Pre-Quote to Contract Conversion', routerLink: '../cPrequotecontractconversion' },
    //   { label: 'Pre-Quote Approval', routerLink: '../Reportapproval' },

    //   // {label: 'Master Creation', routerLink: '',
    //   //   items: [
    //   //     {label: 'Agent Master', routerLink: '../all-components'},
    //   //     {label: 'Branch Master', routerLink: ''},
    //   //     {label: 'Pincode Master', routerLink: ''},
    //   //     {label: 'Training Master', routerLink: ''},
    //   //     {label: 'Customer', routerLink: '../vCustomer'},
    //   //   ]
    //   // },
    //   // {label: 'Report', routerLink: 'AgentRegistrationReport'}
    // ];
  }
}